export function validateContact(values) {
  const errors = {};
  const name = (values.from_name || '').trim();
  const email = (values.from_email || '').trim();
  const subject = (values.subject || '').trim();
  const message = (values.message || '').trim();
  if (!name) errors.from_name = 'Enter your name.';
  else if (name.length > 120) errors.from_name = 'Use 120 characters or fewer.';
  if (!email) errors.from_email = 'Enter your email address.';
  else if (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.from_email = 'Enter a valid email address.';
  if (!subject) errors.subject = 'Enter a subject.';
  else if (subject.length > 160) errors.subject = 'Use 160 characters or fewer.';
  if (!message) errors.message = 'Enter a message.';
  else if (message.length < 10) errors.message = 'Write at least 10 characters.';
  else if (message.length > 5000) errors.message = 'Use 5,000 characters or fewer.';
  return errors;
}
